import { Package } from "lucide-react";
import type { INavItem } from "@/models/INavItem";
import { PackageRoutes } from "./routes";
import { PackagePermissions } from "./permissions";

export const packageNav: INavItem = {
  labelKey: "nav.packages",
  icon: Package,
  path: PackageRoutes.LIST,
  permissions: [PackagePermissions.READ],
};
